import templateUrl from "emun.report/quick-report-prompt.htm";
import QuickReportPromptController from "emun.report/quick-report-prompt.controller";
import modals from "webmodals/modals";

const resolve = () => null;
const reject = reason => console.warn('reject reason', reason);

const QuickReportPrompt = {
  open(options) {
    const prom = modals.open(Object.assign({
      size: 'md quick-report-prompt',
      templateUrl,
      resolve: {
        options: () => options
      },
      bindToController: true,
      controller: QuickReportPromptController,
      controllerAs: '$ctrl'
    }, (options || {}).modal)).result;

    prom.then(resolve, reject);

    return prom;
  }
};

export default QuickReportPrompt;
